export default {"src":"/_next/static/media/bh.c32c5f8e.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};